import React from 'react';

import { ColumnHeaderSortable } from '../../../DataTable/index.jsx';
import PercentageFigure from '../../../PercentageFigure/index.jsx';

import Column from './base.jsx';

const columnOptions = {
  id: 'col-pc-1y',
  title: 'Change Percent (1 Year)'
};


class HeaderColumn extends ColumnHeaderSortable {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return '1y';
  }

  get overlayText() {
    return 'Change % in last year';
  }

  get rightAlign() {
    return true;
  }
}


class DetailColumn extends React.Component {
  render() {
    return (
      <td className="text-right">
        {this.props.row.priceChange1y && <PercentageFigure amount={this.props.row.priceChange1y} />}
      </td>
    );
  }
}


class PriceChange1y extends Column {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  sortAscending(a, b) {
    if (a.priceChange1y < b.priceChange1y) {
      return -1;
    }
    if (a.priceChange1y > b.priceChange1y) {
      return 1;
    }
    return super.sortAscending(a, b);
  }

  sortDescending(a, b) {
    if (a.priceChange1y < b.priceChange1y) {
      return 1;
    }
    if (a.priceChange1y > b.priceChange1y) {
      return -1;
    }
    return super.sortDescending(a, b);
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default PriceChange1y;

